<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
<script lang="ts" setup>
import {PhLinkedinLogo, PhYoutubeLogo} from "@phosphor-icons/vue";
import type {Area} from "#magnolia-layer/types/magnolia-types";
import NavigationItem from "~/components/NavigationItem.vue";

const props = defineProps<{
  metadata: Area;
  linkedin?: string;
  youtube?: string;
  legalPrint?: string;
  copyright?: string;
  navigationRoot?: string;
}>();

const navigation = await resolveNavigationReference(props.navigationRoot);
const navigationItems = computed(() => resolveNavigation(navigation.value));
</script>

<template>
  <div
    class="page-footer bg-black col-span-full content-grid border-t-[1px] border-t-neutral-600 text-white">
    <div class="flex flex-col sm:flex-row justify-between">
      <nav class="text-4xl md:text-6xl lg:text-8xl flex flex-col py-10">
        <template v-for="item in navigationItems">
          <NavigationItem :item></NavigationItem>
        </template>
      </nav>
      <div class="flex flex-col py-10 px-10 gap-20">
        <NuxtLinkLocale to="/">
          <Logo class=""></Logo>
        </NuxtLinkLocale>
        <div v-if="linkedin || youtube" class="socials flex flex-col text-center gap-4 text-xl items-center">
          {{ $t('label.followUs') }}
          <a
            :href="linkedin"
            target="_blank"
            class="inline-flex items-center gap-2" v-if="linkedin">
            <PhLinkedinLogo weight="fill" size="1.5rem"></PhLinkedinLogo>
            LinkedIn
          </a>
          <a :href="youtube" target="_blank"
              class="inline-flex items-center gap-2" v-if="youtube">
            <PhYoutubeLogo weight="fill" size="1.5rem"></PhYoutubeLogo>
            Youtube
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="legal col-span-full content-grid bg-black text-white pb-8">
    <div class="flex justify-between">
      <div class="copyright">
        &copy; {{ new Date().getFullYear() }} <template v-if="copyright">{{ copyright }}</template>
      </div>
      <template v-if="legalPrint">
        <div class="terms" v-interpolate v-html="legalPrint"></div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-footer a {
  @apply text-white duration-300;
  &:hover {
    @apply text-sunrise-100;
  }
}
.legal a {
  text-decoration: underline;
}
</style>
